import React, { useState } from 'react';

import moment from 'moment';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { updateEmployeeDirectoryImport } from '../../actions/update-employee-directory-import';

import { UiButton } from '../../../ui/ui-button';
import { UiDialog } from '../../../ui/ui-dialog';

import { ICON_NAMES, MaterialDesignIcon } from '../../../util/material-design-icons';

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { employeeDirectoryImportId }: EmployeeDirectoryWizardStepProps,
) => ({
  actions: {
    markImportComplete: (isSendEmail: number) =>
      dispatch(
        updateEmployeeDirectoryImport(
          employeeDirectoryImportId,
          {
            completedAt: moment.utc(),
          },
          isSendEmail,
        ),
      ),
  },
});

type Props = EmployeeDirectoryWizardStepProps & ReturnType<typeof mapDispatchToProps>;

export const EmployeeDirectoryImportWizardSuccess = connect(
  null,
  mapDispatchToProps,
)(({ onNext, actions }: Props) => {
  const [isUpdating, setIsUpdating] = useState(false);

  const handleOnNext = async (isSendCustomerEmail: number) => {
    setIsUpdating(true);
    await actions.markImportComplete(isSendCustomerEmail);
    setIsUpdating(false);
    onNext();
  };

  return (
    <>
      <UiDialog.Content>
        <span className="typo-h4">Success!</span>
        <hr />
        <div className="u-flex-center u-justifyContent-center u-width-100">
          <MaterialDesignIcon
            iconName={ICON_NAMES.CHECK_CIRCLE}
            color="success"
            className="u-margin-right-md"
          />
          <div className="u-textAlign-center typo-bold">
            These employees have been successfully imported.
          </div>
        </div>
      </UiDialog.Content>
      <UiDialog.Actions>
        <div>
          <UiButton variant="secondary" onClick={() => handleOnNext(0)} loading={isUpdating}>
            Finish
          </UiButton>
          <UiButton
            className="u-margin-left"
            variant="primary"
            onClick={() => handleOnNext(1)}
            loading={isUpdating}
          >
            Finish and Notify Customer
          </UiButton>
        </div>
      </UiDialog.Actions>
    </>
  );
});
